import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedservicesService } from '../../../../services/sharedservices.service';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
// import {Observable} from 'rxjs';
// import { interval } from 'rxjs';

@Component({
  selector: 'app-complainform',
  templateUrl: './complainform.component.html',
  styleUrls: ['./complainform.component.scss']
})
export class ComplainformComponent implements OnInit {
  heading: any;
  information: any;
  desc: any;;
  sendUserComplaint: any;
  getallEmailid: any;
  apiRoot: string = this.ref.GetPostURL();
  usercheck: any;
  useremail: any;
  submitUserComplaintstatus:any;
  custemail: any;
  custcomplaint: any;
  
  selectstatus: any;
  statusCheck = [
    {
      "name":"active"
    },
    {
      "name":"inactive"
    }];
  constructor(private router: Router, private ref: SharedservicesService, private http: HttpClient) { }

  ngOnInit() {
    var userLoggedin = JSON.parse(localStorage.getItem('customerInfo'));
    if(userLoggedin) {
      this.useremail = userLoggedin.email;
      this.usercheck = userLoggedin.usertype;
      
      this.ref.telecastcomplaint.subscribe(async(heading) => {
        this.information = await heading;
        this.custemail = this.information.customer;
        this.custcomplaint = this.information.heading;
      });
    }
  }
  getAllcustomerEmail(useremail, usercheck) {
    const getcust = {
      'email': useremail,
      'usertype': usercheck
    };
    this.ref.getAllCustomerEmail(getcust).subscribe((res) => {
      const result = JSON.parse(JSON.stringify(res));
      this.getallEmailid = result;
      window.location.reload();
    });
    // this.http.post(getcstemail, getcust).subscribe((res) => {
    //   if (res) {
    //     this.getallEmailid = res;
    //     window.location.reload();
    //   }
    // },
    //   err => {
    //     console.log(err);
    //   }
    // );
  }
  
  onChangestatus(e) {
    this.selectstatus = e.name;
  }

  Changecomplainstatus() {
    var msg = <HTMLElement>document.getElementById('errmsg');
    var successmsg = <HTMLElement>document.getElementById('successmsg');
    
    if(this.custemail && this.custcomplaint && (String(this.selectstatus) !== 'undefined')) {
      msg.style.display = 'none';
      successmsg.style.display = 'block';
      var userLoggedin = JSON.parse(localStorage.getItem('customerInfo'));
      if (userLoggedin) {
        var customerComplaint = {
          'email': userLoggedin.email,
          'customeremail': this.custemail,
          'status':this.selectstatus,
          'auth': userLoggedin.auth,
          'token': userLoggedin.token,
          'userType': userLoggedin.usertype,
          'heading': this.custcomplaint,
          'desc': this.desc,
        };
        if (customerComplaint.userType=='useragent') {
          this.changeStatusComplaint(customerComplaint);
        }
    } else {
      console.log('localstorage empty');
    }
  } else {
    msg.style.display = 'block';
  }
 }
 changeStatusComplaint(customerComplaint) {
  var successmessage = <HTMLElement>document.getElementById('successmsg');
  this.ref.changeCompalintStatus(customerComplaint).subscribe((res) => {
    if (res) {
      const result = JSON.parse(JSON.stringify(res));
      this.submitUserComplaintstatus = result;
      successmessage.style.display = 'block';
      var value = (<HTMLInputElement>document.getElementById("errmsg"));
      value.style.display = 'none';
      console.log('complaint status change!');
      window.location.reload();
    }
  },
    err => {
      console.log(err);
      (<HTMLInputElement>document.getElementById("errmsg1")).innerHTML = err.error.message;
      var value = (<HTMLInputElement>document.getElementById("errmsg1"));
      value.style.display = 'block';
      successmessage.style.display = 'none';
    }
  );
  // this.http.post(posturl3, customerComplaint).subscribe((res) => {
  //   if (res) {
  //     this.submitUserComplaintstatus = res;
  //     successmessage.style.display = 'block';
  //     var value = (<HTMLInputElement>document.getElementById("errmsg"));
  //     value.style.display = 'none';
  //     console.log('complaint status change!');
  //     window.location.reload();
  //   }
  // },
  //   err => {
  //     console.log(err);
  //     (<HTMLInputElement>document.getElementById("errmsg1")).innerHTML = err.error.message;
  //     var value = (<HTMLInputElement>document.getElementById("errmsg1"));
  //     value.style.display = 'block';
  //     successmessage.style.display = 'none';
  //   }
  // );
 }

  Submitcomplaint() {
    console.log('comsint');
    var errmessage = <HTMLElement>document.getElementById('errmsg');
    if (this.heading==undefined && this.desc == undefined) {
      errmessage.style.display = 'block';
    } else if (this.heading!=undefined && this.desc!=undefined) {
      errmessage.style.display = 'none';
      var userLoggedin = JSON.parse(localStorage.getItem('customerInfo'));
      if (userLoggedin) {
        var customerComplaint = {
          'email': userLoggedin.email,
          'auth': userLoggedin.auth,
          'token': userLoggedin.token,
          'userType': userLoggedin.usertype,
          'heading': this.heading,
          'desc': this.desc,
        };
        if (customerComplaint.userType === 'usercustomer') {
          this.SubmitCustomerComplaint(customerComplaint);
        }
      }

    }
  }

  SubmitCustomerComplaint(customerComplaint) {
    var successmessage = <HTMLElement>document.getElementById('successmsg');
    this.ref.changeCompalintStatus(customerComplaint).subscribe((res) => {
      if (res) {
        const result = JSON.parse(JSON.stringify(res));
        this.sendUserComplaint = result;
        console.log(this.sendUserComplaint);
        successmessage.style.display = 'block';
        var value = (<HTMLInputElement>document.getElementById("errmsg1"));
        value.style.display = 'none';
        window.location.reload();
      }
    },
      err => {
        console.log(err);
        (<HTMLInputElement>document.getElementById("errmsg1")).innerHTML = err.error.message;
        var value = (<HTMLInputElement>document.getElementById("errmsg1"));
        value.style.display = 'block';
        successmessage.style.display = 'none';
      }
    );
    // this.http.post(posturl1, customerComplaint).subscribe((res) => {
    //   if (res) {
    //     this.sendUserComplaint = res;
    //     console.log(this.sendUserComplaint);
    //     successmessage.style.display = 'block';
    //     var value = (<HTMLInputElement>document.getElementById("errmsg1"));
    //     value.style.display = 'none';
    //     window.location.reload();
    //   }
    // },
    //   err => {
    //     console.log(err);
    //     (<HTMLInputElement>document.getElementById("errmsg1")).innerHTML = err.error.message;
    //     var value = (<HTMLInputElement>document.getElementById("errmsg1"));
    //     value.style.display = 'block';
    //     successmessage.style.display = 'none';
    //   }
    // );
  }
}
